import { createSlice } from '@reduxjs/toolkit';
import { login, verify } from './action';
import globalConfig from '../../utils/global';

const initialState = {
  token: '',
  isLoading: true,
  userId: '',
  userName: '',
  userCountry: null,
  userEmail: '',
  isLoggedIn: false,
  loginState: {
    loginError: '',
  },
  forgotPasswordState: {
    error: '',
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    init(state, action) {
      state.isLoading = false;
      return state;
    },
    resetState() {
      return initialState;
    },
    setUserCountry(state, action) {
      state.userCountry = action.payload;
    },
    setSession(state, action) {
      state.token = action.payload.token;
      state.userId = action.payload.user.id;
      state.userName = action.payload.user.name;
      state.userEmail = action.payload.user.email;
      state.userCountry = action.payload.user?.country;
      globalConfig.setToken(action.payload.token);
      state.isLoading = false;
      state.isLoggedIn = true;
      state.loginState.loginError = '';
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.fulfilled, (state, action) => {
      state.token = action.payload.token;
      state.userId = action.payload.user.id;
      state.userName = action.payload.user.name;
      state.userEmail = action.payload.user.email;
      state.userCountry = action.payload.user?.country;
      globalConfig.setToken(action.payload.token);
      state.isLoading = false;
      state.isLoggedIn = true;
      state.loginState.loginError = '';
      return state;
    });
    builder.addCase(login.rejected, (state, action) => {
      state.loginState.loginError = action.payload;
    });
    builder.addCase(verify.pending, (state, action) => {
      state.isLoading = true;
      state.isLoggedIn = false;
      return state;
    });
    builder.addCase(verify.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isLoggedIn = true;
      return state;
    });
    builder.addCase(verify.rejected, (state, action) => {
      state.isLoading = false;
      state.isLoggedIn = false;
      return state;
    });
  },
});

export const { init, resetState, setUserCountry, setSession } =
  authSlice.actions;

export default authSlice.reducer;
